import ko from "knockout";

ko.bindingHandlers.textWithLineBreaks = {
    update: function(element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        ko.bindingHandlers.html.update(element, function() { return value.replace(/(?:\r\n|\r|\n)/g, "<br/>"); });
    },
};